query CompanyCorporateYear($id: UUID!) {
  companyCorporateYear(id: $id) {
    id
    fiscalYear
    startDate
    endDate
    isYearOpen
    isEntryAllowed
    _rowTimestamp
    _isUpdatable
    _isDeletable
    companyCorporatePeriodsByFiscalYearId(orderBy: FISCAL_PERIOD_ASC) {
      nodes {
        id
        fiscalYearId
        fiscalPeriod
        startDate
        endDate
        isPeriodOpen
        isEntryAllowed
        _isUpdatable
        _isDeletable
        _rowTimestamp
        corporateYear {
          id
          _rowTimestamp
        }
      }
      totalCount
    }
  }
}
